export default [
    {
        path: '/(uk/|ru/)?/1/orders',
        name: 'WildberriesOrders',
        component: () => import('../views/wildberries/Orders'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon: '#icon-icon-analytic',
            title: 'Поездки',
        },
    }, {
        path: '/(uk/|ru/)?/1/bonus-transactions',
        name: 'WildberriesBonusTransactions',
        component: () => import('../views/wildberries/BonusTransactions'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon: '#icon-icon-analytic',
            title: 'Бонусные транзакции',
        },
    }, {
        path: '/(uk/|ru/)?/1/transactions',
        name: 'WildberriesTransactions',
        component: () => import('../views/wildberries/Transactions'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon: '#icon-icon-analytic',
            title: 'Транзакции',
        },
    },
]